module.exports = {
      id: "burger-usage",
      viewBox: "0 0 25.057 22.4",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#burger",
      toString: function () {
        return this.url;
      }
    }